import React from 'react';
import { StyledErrorFloatCenter, StyledErrorWrap } from '@components/templates/Error/style';
import { PrimaryButton } from '@components/atoms';

const error404 = () => {
  return (
    <StyledErrorWrap>
      <StyledErrorFloatCenter>
        <span className={'error_icon'}></span>
        <p className={'error_tit'}>{`Page not found`}</p>
        <p className={'error_txt'}>{`The page you requested could not be found.`}</p>

        <PrimaryButton
          className={'error_btn'}
          onClick={() => {
            window.history.go(-1);
          }}
        >
          Go to back
        </PrimaryButton>
      </StyledErrorFloatCenter>
    </StyledErrorWrap>
  );
};

export default error404;
